module.exports = __webpack_public_path__ + "img/za.81a39a30.svg";